<template>
    <div class="newsDetail">
        <p class="title">{{info.news_title}}</p>
        <p class="time">{{info.publish_time}}</p>
        <div class="content ql-editor" v-html="info.news_content">
            
        </div>
        <div class="footer">
            <div class="left">
                <p v-if="footerInfo.last" @click="changePage(footerInfo.last.news_id)">上一篇：{{footerInfo.last.news_title}} [{{footerInfo.last.publish_time}}]</p>
                <p v-if="footerInfo.next" @click="changePage(footerInfo.next.news_id)">下一篇：{{footerInfo.next.news_title}} [{{footerInfo.next.publish_time}}]</p>
            </div>
            <a-button type="primary" @click="returnNews()">返回新闻列表 <a-icon type="arrow-right"/></a-button>
        </div>
    </div>
</template>
<script>
import {Button,Icon} from "ant-design-vue"
import {getNewsInfoApi,getNewsListApi} from "@/request/api"
export default {
    name:"newsDetail",
    components:{
        aButton:Button,
        aIcon:Icon
    },
    mounted(){
        this.newsId=this.$route.params.id
        this.init()
    },
    data(){
        return{
            newsId:'',
            info:{},
            footerInfo:{
                last:{},
                next:{}
            }
        }
    },
    methods:{
        init(){
            this.getToken(getNewsInfoApi,{news_id:this.newsId},res=>{
                this.info=res.data
            })
            this.getToken(getNewsListApi,{page_size:1000},res=>{
                let list=res.data.data_info
                let itemIndex
                list.forEach((item,index) => {
                    if(item.news_id==this.newsId){itemIndex=index}
                });
                if(itemIndex==0){
                    this.footerInfo.last=''
                    this.footerInfo.next=list[itemIndex+1]
                }else if(itemIndex==list.length-1){
                    this.footerInfo.last=list[itemIndex-1]
                    this.footerInfo.next=''
                }else{
                    this.footerInfo.last=list[itemIndex-1]
                    this.footerInfo.next=list[itemIndex+1]
                }
            })
        },
        returnNews(){
            this.$router.push({path:'/aboutNews'})
        },
        changePage(id){
            this.newsId=id
            this.init()
        }
    }

}
</script>
<style lang="stylus">
.newsDetail 
    padding:40px 30px;
    .title
        text-align:center;
        font-size:24px;
    .time
        color:#999;
        font-size:18px;
        text-align:center;
        margin-top:-10px;
        margin-bottom:20px;
    .content
        padding:20px;
        font-size:16px;
        color:#333;
        line-height:30px;
        text-align:justify;
        border-bottom:1px solid #cecece;
        .center 
            text-align:center;
    .footer
        display:flex;
        justify-content:space-between;
        align-items:center;
        padding:30px;
        p
            font-size:14px;
            color:#7b7b7b;
            cursor:pointer;
            &:hover
                color:#003cc7

</style>